import {AfterViewInit, Directive, ElementRef, inject} from '@angular/core';

@Directive({
  selector: '[autofocus]',
  standalone: true,
})
export class AutofocusDirective implements AfterViewInit {
  host = inject<ElementRef<HTMLInputElement>>(ElementRef);

  ngAfterViewInit() {
    if (!this.host.nativeElement.autofocus) return;

    this.host.nativeElement.focus();
  }
}
